import { connect } from 'react-redux';
import get from 'lodash.get';
import OlProbeDetails from '../../../../features/probeDetails/shared/ol/OlProbeDetails';
import getOLSentences from '../../../../features/probeDetails/shared/ol/OlUtils';
import { selectors } from '../../../../root/reading/root';
import fetchFormData from '../../../../api/forms/reading/formsActions';

const mapStateToProps = (state, { result }) => {
    const { formUid, itemLevelDetails } = result;
    const sentences = get(selectors.getFormByID(state, formUid), 'sentences', []);

    return {
        listOfSentences: getOLSentences(sentences, itemLevelDetails),
    };
};

const mapDispatchToProps = (dispatch, { result }) => ({
    fetchSentences: () => dispatch(fetchFormData(result.measure, result.formUid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OlProbeDetails);
